//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { deserializeMediaItem } from '@apis/media-library/mediaLibraryApiUtils';
import {
  IMlsMaterializedPin,
  IPinterestPinResponse,
} from '@apis/pinterest-pins/pinterestPinsApiModel';
import PinterestPinId from '@models/PinterestPinId';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { Serialized } from '@utils/types/Serialized';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const PINTEREST_PIN_ENDPOINT = '/api/v1/pins';

const pinterestGatewayPinsFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'pinterest_dashboard_gateway',
    `${PINTEREST_PIN_ENDPOINT}${endpoint}`,
    init,
  );
};

export const deserializePin = (
  pin: Serialized<IMlsMaterializedPin>,
): IMlsMaterializedPin => {
  return {
    ...pin,
    mediaItem: pin.mediaItem && deserializeMediaItem(pin.mediaItem),
  };
};

/**
 * Gets a pin
 *
 * GET /api/v1/pins/:id
 */
export const getPin = async (
  pinId: PinterestPinId,
): Promise<IMlsMaterializedPin> => {
  const res = await pinterestGatewayPinsFetch(`/${pinId}`);

  const deserializedResponse = await res.json<IPinterestPinResponse>(
    (response: Serialized<IPinterestPinResponse>): IPinterestPinResponse => {
      return {
        data: deserializePin(response.data),
      };
    },
  );

  return deserializedResponse.data;
};
